import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { translate } from "react-translate";
import AnomaliesEditForm from 'components/ListAnomalies/AnomaliesEditForm';

const AnomaliesEdit = (props) => {
  const {t} = props;
  
  return (
    <div className='content user-manual'>
      <Card>
        <CardHeader>
          <h5 className="title">{t("title-header")}</h5>
        </CardHeader>
        <CardBody>
          <AnomaliesEditForm />
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("anomalies")(AnomaliesEdit);
